// @ts-nocheck
/* eslint-enable */
import React, { Fragment } from 'react';
import { useSelector } from 'react-redux';
import cx from 'classnames';
import { withRouter } from 'react-router-dom';

import 'app/shared/modules/navigation/FilterNav/style.scss';
import AlertButton from 'app/shared/modules/MobileSRP/ListingCards/ListingHeader/AlertsButton';
import AutocompleteSearchInput from 'app/shared/modules/location/AutocompleteSearchInput';
import FilterModalController from 'app/shared/modules/filter/FilterModalController';
import InlineFilter from 'app/shared/modules/filter/InlineFilter';
import routeUtils from 'app/shared/utils/routeUtils';

const FilterNav = () => {
  const isMobile = useSelector((state) => state.app.device.screenWidth === 'sm');
  const pathname = useSelector((state) => state.location.current.pathname);
  const isPadOrBuildingUrl = routeUtils.isPadOrBuildingUrl(pathname);

  return (
    <Fragment>
      <section
        aria-label="filter"
        className={cx('FilterNav', {
          'hide-on-mweb-hdp': isPadOrBuildingUrl,
        })}
      >
        <div className="FilterNav-container">
          {!isMobile && (
            <div className="FilterNav-search-wrapper">
              <AutocompleteSearchInput
                includeCancel
                includeClear
                full
                useSmallScreenWidthDropdown
                triggerLocation="search_results"
                triggerObject="filter_panel"
              />
            </div>
          )}
          <InlineFilter />
          <div className="FilterNav-alert-button">
            <AlertButton />
          </div>
        </div>
      </section>
      <FilterModalController />
    </Fragment>
  );
};

export default withRouter(FilterNav);
